<div *ngIf="requestState">
    <div style="margin: 0 1.5em" *ngIf="displayTable">
        <table
            class="mt-table mt-table-striped"
            aria-label="table-minute-by-minute"
        >
            <thead>
                <tr>
                    <th scope="col" sortable="shift" (sort)="onSort($event)">
                        <div class="row mt-sort-header">
                            <div class="col-7">
                                <div class="mt-header-name-sort">
                                    {{ "singular-shift" | lang }}
                                </div>
                            </div>
                            <div class="col-5">
                                <div
                                    *ngIf="
                                        column !== 'shift' || direction === ''
                                    "
                                    class="mt-sort-header-icon"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-up"
                                    />
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-down"
                                    />
                                </div>
                                <div
                                    *ngIf="
                                        direction === 'asc' &&
                                        column === 'shift'
                                    "
                                    class="mt-sort-header-icon mt-sort-up"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-up"
                                    />
                                </div>
                                <div
                                    *ngIf="
                                        direction === 'desc' &&
                                        column === 'shift'
                                    "
                                    class="mt-sort-header-icon mt-sort-down"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-down"
                                    />
                                </div>
                            </div>
                        </div>
                    </th>
                    <th
                        scope="col"
                        sortable="completedAt"
                        (sort)="onSort($event)"
                    >
                        <div class="row mt-sort-header">
                            <div class="col-6">
                                <div class="mt-header-name-sort">
                                    {{ "date" | lang }}
                                </div>
                            </div>
                            <div class="col-5">
                                <div
                                    *ngIf="
                                        column !== 'completedAt' ||
                                        direction === ''
                                    "
                                    class="mt-sort-header-icon"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-up"
                                    />
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-down"
                                    />
                                </div>
                                <div
                                    *ngIf="
                                        direction === 'asc' &&
                                        column === 'completedAt'
                                    "
                                    class="mt-sort-header-icon mt-sort-up"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-up"
                                    />
                                </div>
                                <div
                                    *ngIf="
                                        direction === 'desc' &&
                                        column === 'completedAt'
                                    "
                                    class="mt-sort-header-icon mt-sort-down"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-down"
                                    />
                                </div>
                            </div>
                        </div>
                    </th>
                    <th
                        scope="col"
                        sortable="machineName"
                        (sort)="onSort($event)"
                    >
                        <div class="row mt-sort-header">
                            <div class="col-7">
                                <div class="mt-header-name-sort">
                                    {{ "machineName" | lang }}
                                </div>
                            </div>
                            <div class="col-5">
                                <div
                                    *ngIf="
                                        column !== 'machineName' ||
                                        direction === ''
                                    "
                                    class="mt-sort-header-icon"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-up"
                                    />
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-down"
                                    />
                                </div>
                                <div
                                    *ngIf="
                                        direction === 'asc' &&
                                        column === 'machineName'
                                    "
                                    class="mt-sort-header-icon mt-sort-up"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-up"
                                    />
                                </div>
                                <div
                                    *ngIf="
                                        direction === 'desc' &&
                                        column === 'machineName'
                                    "
                                    class="mt-sort-header-icon mt-sort-down"
                                >
                                    <img
                                        appImageSelector
                                        alt="mt-image"
                                        imageType="icon"
                                        imageKey="sort-down"
                                    />
                                </div>
                            </div>
                        </div>
                    </th>
                    <th scope="col">
                        <div class="mt-header-name">{{ "message" | lang }}</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let md of minutesData">
                    <td>{{ md.shift }}</td>
                    <td>{{ md.completedAt | fullDateTimePresentation }}</td>
                    <td>{{ md.machineName }}</td>
                    <td>{{ md.message }}</td>
                </tr>
            </tbody>
        </table>
        <div class="d-flex justify-content-between pt-2">
            <div class="mt-page-size">
                {{ "showing" | lang }}
                <select
                    class="mt-select-page"
                    style="width: auto"
                    [(ngModel)]="pageSize"
                    (change)="changePageSize()"
                >
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="20">20</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                </select>
                {{ "from-total-of" | lang }} {{ this.collectionSize }}
            </div>
            <div class="mt-pagination">
                <img
                    (click)="goBackPage()"
                    *ngIf="displayBackIcon"
                    appImageSelector
                    alt="mt-image"
                    imageType="icon"
                    imageKey="left-pagination"
                />
                <span>
                    <input
                        *ngIf="displayInputPage; else default"
                        (keypress)="numberOnly($event)"
                        (keyup)="setPage()"
                        (change)="setPage()"
                        [(ngModel)]="inputPage"
                        min="1"
                        [max]="amountPages"
                    />
                    de {{ amountPages }}
                    <ng-template #default>1</ng-template>
                </span>
                <img
                    (click)="advancePage()"
                    *ngIf="displayRightIcon"
                    appImageSelector
                    alt="mt-image"
                    imageType="icon"
                    imageKey="right-pagination"
                />
            </div>
        </div>
    </div>
</div>
